import { ApiResponse, fetcher } from './base-api';
import { SiteCategory } from './types/globals.type';
import {
  GetStoreReviewListParams,
  StoreReviewEntity,
  StoreReviewListResponse,
} from './types/store-review.type';

export const getFeaturedStoreReviewList = async (): Promise<
  ApiResponse<StoreReviewEntity[]>
> => {
  return fetcher<StoreReviewEntity[]>('/store-review/featured', {
    params: {
      category: SiteCategory.TRAINING,
    },
  });
};

// export const getStoreReviewList = async (
//   storeId: number,
// ): Promise<ApiResponse<StoreReviewEntity[]>> => {
//   return fetcher<StoreReviewEntity[]>(`/store-review/store/${storeId}`);
// };

export const getStoreReviewList = async (
  params: GetStoreReviewListParams,
): Promise<ApiResponse<StoreReviewListResponse>> => {
  return fetcher<StoreReviewListResponse>(
    `/store-review/store/${params.storeId}`,
    {
      params,
    },
  );
};
